"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCouponDiscountLabel = exports.default = exports.APPLY_COUPON_PAGE_DEFAULTS = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactLottie = _interopRequireDefault(require("react-lottie"));
var _CouponTicketCard = _interopRequireDefault(require("../CouponTicketCard/CouponTicketCard"));
var _couponOffer = require("../../utils/couponOffer");
var _noCoupons = _interopRequireDefault(require("./animations/no-coupons.json"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const APPLY_COUPON_PAGE_DEFAULTS = exports.APPLY_COUPON_PAGE_DEFAULTS = {
  title: 'Apply Coupon',
  sectionTitle: 'Available Coupons',
  inputPlaceholder: 'Enter coupon code',
  applyText: 'APPLY',
  emptyText: 'No coupons available for you!',
  invalidCodeText: 'This coupon code is invalid',
  fontFamily: 'Inter, sans-serif',
  emptyBackground: 'linear-gradient(to bottom, #ffffff 16.733%, #ede8ff 103.49%)',
  emptyAnimation: _noCoupons.default,
  emptyAnimationSize: 200,
  colors: {
    background: '#fafafa',
    header: '#ffffff',
    title: '#222226',
    sectionTitle: '#0f0b28',
    field: '#ffffff',
    fieldBorder: '#e5e4e7',
    placeholder: '#b1afb6',
    inputText: '#222226',
    brand: 'var(--primary-button, #714fff)',
    error: '#ef4444',
    muted: '#686670'
  }
};
const SlideUp = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Slide, {
  direction: "up",
  ref: ref,
  ...props
}));
const BackIcon = _ref => {
  let {
    color = '#000000'
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M15 19L8 12L15 5",
      stroke: color,
      strokeWidth: "1.7",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
const getCouponDiscountLabel = function () {
  let coupon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (coupon.discountLabel) return coupon.discountLabel;
  if (coupon.offLabel) return coupon.offLabel;
  const amount = (0, _couponOffer.getCouponOffAmount)(coupon);
  return amount ? `${amount} OFF` : 'OFFER';
};

// A handler can reject an apply outright — by throwing, returning false, or
// resolving to something carrying success: false / an error message.
exports.getCouponDiscountLabel = getCouponDiscountLabel;
const readFailure = result => {
  if (result === false) return {};
  if (result && typeof result === 'object') {
    const message = result.errorMessage || result.couponMessage || result.message;
    if (result.success === false || result.error) return {
      message
    };
  }
  return null;
};
const errorText = err => err?.response?.data?.message || err?.response?.data?.errorMessage || null;
const defaultMapCoupon = function () {
  let coupon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    code: coupon.couponCode,
    discountLabel: getCouponDiscountLabel(coupon),
    description: coupon.couponDescription,
    details: coupon.couponSubDescription
  };
};

/**
 * Full-screen "Apply Coupon" page. Only one coupon can be applied at a time —
 * applying a second one swaps it for the first, and every action is blocked
 * while a request is in flight.
 *
 * onApply/onRemove are called as (code, { manual }) — `manual` is true for a
 * code typed into the input, false for one picked from the list.
 */
const ApplyCouponPage = _ref2 => {
  let {
    open = false,
    onClose,
    coupons = [],
    appliedCouponCode,
    onApply,
    onRemove,
    mapCoupon = defaultMapCoupon,
    closeOnApply = true,
    allowManualCode = true,
    verifyManualCode = true,
    error,
    invalidCodeText = APPLY_COUPON_PAGE_DEFAULTS.invalidCodeText,
    title = APPLY_COUPON_PAGE_DEFAULTS.title,
    sectionTitle = APPLY_COUPON_PAGE_DEFAULTS.sectionTitle,
    inputPlaceholder = APPLY_COUPON_PAGE_DEFAULTS.inputPlaceholder,
    applyText = APPLY_COUPON_PAGE_DEFAULTS.applyText,
    emptyText = APPLY_COUPON_PAGE_DEFAULTS.emptyText,
    emptyAnimation = APPLY_COUPON_PAGE_DEFAULTS.emptyAnimation,
    emptyAnimationSize = APPLY_COUPON_PAGE_DEFAULTS.emptyAnimationSize,
    emptyAnimationLoop = true,
    emptyBackground = APPLY_COUPON_PAGE_DEFAULTS.emptyBackground,
    fontFamily = APPLY_COUPON_PAGE_DEFAULTS.fontFamily,
    colors: colorsProp,
    cardProps = {},
    sx = {},
    ...rest
  } = _ref2;
  const colors = {
    ...APPLY_COUPON_PAGE_DEFAULTS.colors,
    ...colorsProp
  };
  const [pendingCode, setPendingCode] = (0, _react.useState)(null);
  const [codeInput, setCodeInput] = (0, _react.useState)('');
  const [failure, setFailure] = (0, _react.useState)(null);
  const unverifiedRef = (0, _react.useRef)(null);
  const appliedCode = appliedCouponCode ?? coupons.find(coupon => coupon?.isApplied)?.couponCode ?? null;
  const busy = pendingCode !== null;
  const finishApply = () => {
    setCodeInput('');
    if (closeOnApply) onClose?.();
  };
  const runAction = async function (code, isApply) {
    let manual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const handler = isApply ? onApply : onRemove;
    if (busy || !code || !handler) return;
    setFailure(null);
    setPendingCode(code);
    try {
      const rejected = readFailure(await handler(code, {
        manual
      }));
      if (rejected) {
        setFailure(rejected.message || invalidCodeText);
        return;
      }
      if (!isApply) return;
      // The handlers here refetch rather than report validity, so a typed code
      // is only trusted once it comes back applied.
      if (manual && verifyManualCode) unverifiedRef.current = code;else finishApply();
    } catch (err) {
      setFailure(errorText(err) || invalidCodeText);
    } finally {
      setPendingCode(null);
    }
  };

  // Don't carry a stale code or error into the next time the page opens.
  (0, _react.useEffect)(() => {
    if (open) return;
    unverifiedRef.current = null;
    setFailure(null);
    setCodeInput('');
  }, [open]);
  (0, _react.useEffect)(() => {
    const submitted = unverifiedRef.current;
    if (!submitted || busy) return;
    unverifiedRef.current = null;
    if (appliedCode === submitted) finishApply();else setFailure(invalidCodeText);
    // finishApply/invalidCodeText are stable enough for this one-shot check
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedCode, busy]);
  const typedCode = codeInput.trim().toUpperCase();
  const shownError = error ?? failure;
  const isEmpty = coupons.length === 0;
  const pageBackground = isEmpty ? emptyBackground : colors.background;
  const handleCodeChange = e => {
    setCodeInput(e.target.value);
    if (failure) setFailure(null);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Dialog, {
    fullScreen: true,
    open: open,
    onClose: onClose,
    TransitionComponent: SlideUp,
    PaperProps: {
      sx: {
        background: pageBackground
      }
    },
    ...rest,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      sx: {
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: pageBackground,
        fontFamily,
        ...sx
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        sx: {
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          px: '20px',
          py: '8px',
          background: colors.header,
          position: 'sticky',
          top: 0,
          zIndex: 1
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ButtonBase, {
          disableRipple: true,
          onClick: onClose,
          "aria-label": "Go back",
          sx: {
            px: '4px',
            py: '8px'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(BackIcon, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            flex: '1 0 0',
            minWidth: 0,
            fontFamily,
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: 1.3,
            letterSpacing: '-0.12px',
            color: colors.title,
            m: 0
          },
          children: title
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        sx: {
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          px: '20px',
          py: '16px',
          pb: '32px',
          boxSizing: 'border-box'
        },
        children: [allowManualCode && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
          sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
            sx: {
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              p: '12px',
              borderRadius: '12px',
              border: `1px solid ${colors.fieldBorder}`,
              background: colors.field,
              boxShadow: '0px 0px 0px 1px #fafafa, 0px 0px 2px 0px rgba(0, 0, 0, 0.06)'
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.InputBase, {
              value: codeInput,
              onChange: handleCodeChange,
              placeholder: inputPlaceholder,
              inputProps: {
                'aria-label': inputPlaceholder
              },
              sx: {
                flex: '1 0 0',
                minWidth: 0,
                fontFamily,
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: 1.4,
                letterSpacing: '-0.12px',
                color: colors.inputText,
                '& input': {
                  p: 0,
                  textTransform: 'uppercase'
                },
                '& input::placeholder': {
                  color: colors.placeholder,
                  opacity: 1,
                  textTransform: 'none'
                }
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ButtonBase, {
              disableRipple: true,
              disabled: busy || !typedCode,
              onClick: () => runAction(typedCode, true, true),
              sx: {
                flexShrink: 0,
                opacity: typedCode ? 1 : 0.4
              },
              children: pendingCode && pendingCode === typedCode ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
                size: 14,
                sx: {
                  color: colors.brand
                }
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
                sx: {
                  fontFamily,
                  fontWeight: 600,
                  fontSize: '12px',
                  lineHeight: 1.6,
                  color: colors.brand,
                  whiteSpace: 'nowrap',
                  m: 0
                },
                children: applyText
              })
            })]
          }), shownError && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
            role: "alert",
            sx: {
              fontFamily,
              fontWeight: 500,
              fontSize: '11px',
              lineHeight: 1.5,
              letterSpacing: '-0.12px',
              color: colors.error,
              m: 0
            },
            children: shownError
          })]
        }), isEmpty ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
          sx: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '24px',
            // sits above the optical centre, as in the design
            pb: '120px'
          },
          children: [emptyAnimation && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
            "aria-hidden": true,
            sx: {
              flexShrink: 0,
              width: `${emptyAnimationSize}px`,
              height: `${emptyAnimationSize}px`,
              pointerEvents: 'none'
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLottie.default, {
              options: {
                loop: emptyAnimationLoop,
                autoplay: true,
                animationData: emptyAnimation,
                rendererSettings: {
                  preserveAspectRatio: 'xMidYMid meet'
                }
              },
              height: emptyAnimationSize,
              width: emptyAnimationSize,
              isClickToPauseDisabled: true,
              ariaRole: "presentation",
              ariaLabel: ""
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
            sx: {
              width: '100%',
              fontFamily,
              fontWeight: 500,
              fontSize: '18px',
              lineHeight: 1.4,
              letterSpacing: '-0.12px',
              textAlign: 'center',
              color: colors.muted,
              m: 0
            },
            children: emptyText
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
          sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          },
          children: [sectionTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
            sx: {
              fontFamily,
              fontWeight: 600,
              fontSize: '14px',
              lineHeight: 1.4,
              letterSpacing: '0.25px',
              color: colors.sectionTitle,
              m: 0
            },
            children: sectionTitle
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
            sx: {
              display: 'flex',
              flexDirection: 'column',
              gap: '16px'
            },
            children: coupons.map((coupon, index) => {
              const card = mapCoupon(coupon, index);
              const applied = !!card.code && card.code === appliedCode;
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CouponTicketCard.default, {
                ...card,
                applied: applied,
                loading: pendingCode === card.code,
                disabled: busy && pendingCode !== card.code,
                onApply: code => runAction(code, true),
                onRemove: code => runAction(code, false),
                ...cardProps
              }, card.code ?? index);
            })
          })]
        })]
      })]
    })
  });
};
var _default = exports.default = ApplyCouponPage;